import { render, staticRenderFns } from "./DITInstallation.vue?vue&type=template&id=5d1fb212&scoped=true&"
import script from "./DITInstallation.vue?vue&type=script&lang=js&"
export * from "./DITInstallation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1fb212",
  null
  
)

export default component.exports